import axios from 'axios';

async function createHelpRequest(data) {
  const response = await axios.post('/providers/helprequests', data);

  return response.data;
}

async function getHelpRequests() {
  const response = await axios.get('/providers/helprequests');

  return response.data;
}

const helpRequestsService = {
  createHelpRequest,
  getHelpRequests,
}

export default helpRequestsService;
